<template>
    <b-container>
        <b-row>
            <b-col cols="4" offset="2">
                <b-card>
                    <h2 class="text-center">
                        Forgot Password?
                    </h2>
                    <h1 class="font-weight-bold text-center">
                        <b-icon-lock font-scale="2"></b-icon-lock>
                    </h1>
                    <b-card-text class="text-center">
                        You can reset your password here.
                    </b-card-text>
                    <b-card-text v-if="emailSent" class="p-1 text-light border-dark bg-success">
                        Password reset submitted.
                    </b-card-text>
                    <b-card-text v-if="emailSent">
                        If you have an account with us you should receive an email with a password reset link shortly.
                    </b-card-text>
                    <b-card-text class="text-white bg-danger p-1 border-dark border" v-if="error !== null">
                        {{error}}
                    </b-card-text>
                    <b-form @submit.prevent="resetEmail">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <b-icon-envelope></b-icon-envelope>
                            </b-input-group-prepend>
                            <b-input v-model="email" label="Email:" placeholder="example@domain.com" required />
                        </b-input-group>
                        <b-button class="mt-3" type="submit" variant="primary"><b-icon-arrow-clockwise /> Reset Password</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Auth from "@/fstore/auth";

export default {
    name: "ForgotPassword",
    data() {
        return {
            email: "",
            error: null,
            emailSent: false
        }
    },
    methods:{
        async resetEmail() {
            this.emailSent = false;
            if(this.email == null || this.email == ""){
                this.error = "Email is required"
                return false;
            }

            this.$store.dispatch("app/setOverlay", true);
            this.error = await Auth.resetPassword(this.email);

            if(this.error == null) {
                this.emailSent = true;
                this.email = "";
            }

            this.$store.dispatch("app/setOverlay", false);
        }
    }
}
</script>